import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Carousel from "@/_components/Carousel";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styledSlots, resolveStyledSlots } from "../_helpers/styledSlots";
const WhiteTextTypography = styled(Typography)(({ theme }) =>
  styledSlots(
    resolveStyledSlots(
      {
        root: {
          color: "#fff",
          fontWeight: 600,
        },
      },
      theme,
    ),
  ),
);
const componentStyles = (theme) => ({
  customTypo: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      fontSize: 36,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 24,
    },
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
function AccountCarousel() {
  const { t } = useTranslation();
  const items = [
    {
      name: t("carousel.name1"),
      description: t("carousel.description1"),
      imagePath: "./src/_images/calendar_fff.png",
    },
    {
      name: t("carousel.name2"),
      description: t("carousel.description2"),
      imagePath: "./src/_images/pay_fff.png",
    },
    {
      name: t("carousel.name3"),
      description: t("carousel.description3"),
      imagePath: "./src/_images/resources_fff.png",
    },
  ];
  return (
    <StyledRoot>
      <Carousel>
        {items.map((carouselItem, i) => (
          <Grid
            key={i}
            container
            style={{
              height: "calc(100vh - 50px)",
              minHeight: 475,
              padding: 15,
            }}
            sx={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid>
              <img
                src={carouselItem.imagePath}
                alt={carouselItem.name}
                width="100%"
              />
            </Grid>
            <Grid>
              <WhiteTextTypography className={"customTypo"}>
                {carouselItem.name}
              </WhiteTextTypography>
            </Grid>
            <Grid
              style={{
                textAlign: "center",
              }}
            >
              <WhiteTextTypography variant="h6">
                {carouselItem.description}
              </WhiteTextTypography>
            </Grid>
          </Grid>
        ))}
      </Carousel>
    </StyledRoot>
  );
}
AccountCarousel.propTypes = {
  carouselItem: PropTypes.object,
};
export { AccountCarousel };
